<template>
<div class="container">
  <div class='base_line'></div>
  <div class='icon_line'>
    <p class="title">{{$t('Enter veri')}}</p>
     <img src="../assets/Verfication Code.png">
  </div>
  <div class='tips' v-html="$t('t1215_Multi_factor_ON').replace('$1', routeData.user_name)">
<!--    <p>Multi-factor authentication is On.</p>-->
<!--    <p>Verification code has been sent to</p>-->
<!--    <p>{{routeData.user_name}}</p>-->
<!--    <p>please submit code</p>-->
  </div>
    <el-tooltip placement="top-start" :disabled="!isErrorCode" effect="light">
      <div slot="content" class="tooltip">{{$t('errtip3')}}</div>
      <el-input  v-model="mfa_seccode"  :placeholder="$t('Entercode')" :class="{'alert_border':isErrorCode}">
        <el-button slot="append" class="login" @click="getCode()">{{codeText}}</el-button>
      </el-input>
    </el-tooltip>
  <button class="register" @click="next">{{$t('Next')}}</button>
</div><!--container结束-->
</template>
<script>
import auth from '../auth/auth'
export default {
  data() {
    return {
      routeData:{},
      mfa_seccode:'',
      codeText: this.$t('Getcode'),
      canGetCode: true,
      isErrorCode: false,
      tipHtml:''
    }
  },
  created() {
    this.routeData = JSON.parse(sessionStorage.getItem('loginInfo'))
    this.tipHtml = this.$t('t1215_Multi_factor_ON')
  },
  watch: {
    mfa_seccode(val, oldval){
      this.isErrorCode = false
    }
  },
  methods: {
    next() {
      this.routeData.mfa_seccode = this.mfa_seccode
      const postData = this.routeData
      auth.login(this, postData)
    },
    setCode(){
      this.canGetCode = false
      let time = 60
      this.codeText = `${time} s`
      let timer = setInterval(()=>{
        if(time<=0){
          clearInterval(timer)
          this.canGetCode = true
          this.codeText = this.$t('Getcode')
        }else{
          time -= 1
          this.codeText = `${time} s`
        }
      }, 1000)

    },
    getCode() {
      this.isErrorCode = false
      if(this.canGetCode){
        const postData = {
          user_name: this.routeData.user_name,
          flag: this.routeData.user_name.match(/^[\d]+$/g)?'mobile':'email',
          country: this.routeData.country,
          purpose:'login_mfa'
        }
        this.$http.post('/api/v2.0/seccode/send', postData).then(res=>{
          if(res.body.error === 0){
            this.setCode()
          }else if(res.body.error===1){
            let tip =this.$t('userNotExist');
            this.$message.error(tip);
          }else{
            let tip =this.$t('tryAgain');
            this.$message.error(tip);
          }
        })
      }
    }
  },
}
</script>
<style scoped>
  .container{
    width:400px;
    height:520px;
    margin: 0 auto;
    background: rgba(235,238,241,0.6);
    border-radius:14px;
    text-align: center;
  }
  .container img{
    display: block;
    margin: 0 auto;
  }
  .container p{
    margin:0 auto;
    color:#2aace0;
    letter-spacing:-0.88px;
    line-height:30px;
    font-size: 20px;
    text-align:center;
    /* margin-bottom:50px; */
  }
  .tips {
    width:80%;
    margin: 0 auto;
    text-align:left;
  }
  .tips p{
    color:#323232;
    text-align:left;
    padding-left: 30px;
    font-size: 22px;
  }
  .base_line {
    opacity: 0;
    height: 1px;
  }
  .icon_line {
    /*background-color: aliceblue;*/
    /*font-weight: bold;*/
    font-family: SFUIText-Medium;
    margin: 40px auto;
    width: 80%;
    height: 110px;
  }

  .icon_line p {
    color:#323232;
    font-size:26px;
    margin-bottom: 20px;
  }

  .icon_line img {
    height:80px;
    width:80px;
  }

  @media screen and (max-width: 1500px){
    .container{
      height:520px;
    }
    .container #user{
      margin:35px 162px 20px;
    }
    .container p{
      margin-bottom:0px;
    }
    .icon_line .title {
      margin-bottom: 30px;
    }
  }
  .next {
    width: 80%;
    border-radius: 4px;
    height: 30px;
    background-color: #3399ff;
    color: white;
    margin-top: 50px;
  }
  .toolTip {
    background-color: yellow;
    color: black;
  }
  .register {
    height: 46px;
    line-height: 46px;
    width: 80%;
    font-family: SFUIText-Regular;
    background:#009fdf;
    border-radius:100px;
    font-size:20px;
    color:#f6f9fb;
    letter-spacing:-0.49px;
    text-align:center;
    cursor: pointer;
    outline: none;
    border:none;
    margin-top: 13%;
  }
  .alert_border {
    border: 1px solid red;
  }
  >>> .el-input-group{
    width: 80%;
    margin-top: 50px;
    border-radius: 30px;
    overflow: hidden;
    height: 46px;
  }
  >>> .el-input__inner {
    height: 46px;
  }
  >>> .el-input-group__append {
    background-color: #00ccff;
    color: white;
    cursor: pointer;
  }
  >>> .popper__arrow::after{
    background-color: yellow;
  }
  >>> .el-tooltip__popper.is-dark{
    background: yellow;
    color: black;
  }
  >>> .el-input{
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// verificationCode.vue?6eaeeed1